module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00295.4c79d88f.jpg";